<script>
import {myMixins} from "../mixins/myMixins";
import {invoicesService} from "../../Services/Invoices.service";

export default {
    name: "Refund",
    mixins: [myMixins],
    props: {
        role_id: {
            type: Number,
            comments: 'Es el rol del usuario que esta cargando la factura, se usa para obtener el directorio donde se guarda el archivo de la factura',
            required: true
        },
        reg_id: {
            type: Number,
            comments: 'Es el id del usuario que esta autenticado',
            required: true
        },

    },
    data() {
        return {
            filter: null,
            isBusy: false,
            showModal: false,
            titleModal: 'Subir Factura',
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            invoice: [],
            fields: [
                {key: 'factura_name'},
                {key: 'concepto'},
                {key: 'subtotal'},
                {key: 'iva'},
                {key: 'total'},
                {key: 'status'},
                {key: 'acciones'},
            ],
            params: {
                limit: 10,
                page: 1,
                where: [
                    {
                        field: 'supplier_id',
                        operator: '=',
                        value: this.reg_id
                    },
                    {
                        field: 'model_type',
                        operator: '=',
                        value: 'App\\Models\\AffiliateTitular'
                    }],
            },
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = '';
            resp = await invoicesService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        closeModal() {
            this.showModal = false;
        },
        openModal() {
            this.showModal = true;
        },
        changeLimit() {
            this.index();
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        async index() {
            this.isBusy = true;
            //console.log('this.params=', this.params)
            this.pagination = await invoicesService.getMany(this.params);
            //console.log('this.pagination Refund=', this.pagination);
            this.isBusy = false;
        },
    },
    mounted() {
        console.log('REFUND ROLE_ID =', this.role_id)
        this.index();
    }
}
</script>

<template>
    <div id="quoter-component">
        <b-modal @hide="closeModal" v-model="showModal" id="modal-cotizador" hide-footer size="xl" centered scrollable
                 :title="titleModal" ref="modal-serv">
            <upload-invoice
                :role_id="role_id"
                :type_invoice="3"
                :reg_id="reg_id">
            </upload-invoice>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-3 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                          v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12  col-xl-5 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12  col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <button class="formSubmit" type="button" v-on:click="openModalsProviders()">
                                Reembolso
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" :filter="filter">
                            <template #head(acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>

                            <template #cell(factura_name)="{item}">

                                {{ item.factura_name }}

                            </template>
                            <template #cell(concepto)="{item}">

                                {{ item.concepto }}

                            </template>
                            <template #cell(subtotal)="{item}">

                                {{ formatPrice(item.subtotal) }}

                            </template>
                            <template #cell(iva)="{item}">

                                {{ formatPrice(item.iva) }}

                            </template>
                            <template #cell(total)="{item}">
                                {{ formatPrice(item.total) }}
                            </template>
                            <template #cell(status)="{item}">
                                <span v-if="item.approved_at!=null" class="badge rounded-pill text-bg-success">
                                    <i class="fa-solid fa-circle-check"></i>
                                </span>
                                <span v-else class="badge rounded-pill text-bg-orange">
                                    <i class="fa-solid fa-circle-exclamation"></i>
                                </span>
                            </template>

                            <template #cell(acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">
                                            Borrar
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                          v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<style scoped>

</style>
